<lvr-heading>{{ 'client.disability.type.edit.title' | transloco }}</lvr-heading>
<form [formGroup]="form" lvrAutoSave="disabilityType" [entityId]="draftId()" [autoLoad]="false" class="form-container">
	<section class="form-grid">
		<!-- Status as of -->
		@let statusCtrl = form.get('statusAsOf');
		<lvr-field
			[label]="'client.disability.type.edit.status_as_of' | transloco | appendAsterisk"
			[matTooltip]="'client.disability.type.create.sb_hint' | transloco"
		>
			@if (canEdit('statusAsOf')) {
				<mat-form-field
					lvrInput
					[lvrError]="hasError(statusCtrl, 'matDatepickerParse', 'matDatepickerMin', 'matDatepickerMax', 'required')"
				>
					<input
						matInput
						[matDatepicker]="picker"
						[min]="minStatusDate()"
						[max]="maxStatusDate()"
						formControlName="statusAsOf"
						placeholder="04.06.2013"
						[errorStateMatcher]="matcher"
					/>
					@if (hasError(statusCtrl, 'matDatepickerParse')) {
						<mat-error>{{ 'base.form.error.date_format_invalid' | transloco: { format: dateFormatHint } }}</mat-error>
					} @else if (hasError(statusCtrl, 'matDatepickerMin') && !isStatusDateBoundByContactPhase()) {
						<mat-error>{{
							'base.form.error.date_min_error' | transloco: { minDate: (minStatusDate() | date: dateDisplayFormat) }
						}}</mat-error>
					} @else if (hasError(statusCtrl, 'matDatepickerMin') && isStatusDateBoundByContactPhase()) {
						<mat-error>
							{{
								'client.disability.type.edit.error.status_date_bound_by_contact_phase'
									| transloco
										: {
												minDate: (minStatusDate() | date: dateDisplayFormat),
										  }
							}}
						</mat-error>
					} @else if (hasError(statusCtrl, 'matDatepickerMax')) {
						<mat-error>{{ 'base.form.error.date_max_error' | transloco }}</mat-error>
					} @else if (hasError(statusCtrl, 'required')) {
						<mat-error>{{ 'client.disability.type.edit.error.required' | transloco }}</mat-error>
					}
					<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
					<mat-datepicker #picker></mat-datepicker>
					<mat-hint>{{ dateFormatHint }}</mat-hint>
				</mat-form-field>
			} @else {
				<p class="readonly">
					{{ isValidDate(kind().statusAsOf) ? (kind().statusAsOf | date: dateDisplayFormat) : '' }}
				</p>
			}
		</lvr-field>

		<!-- Placeholder (Spacer) -->
		<div></div>

		<!-- Disability Type -->
		@let typeCtrl = form.controls.disabilityType;
		<lvr-field [label]="'base.field.disability_type' | transloco | appendAsterisk">
			@if (canEdit('disabilityType')) {
				<lvr-searchable-select
					formControlName="disabilityType"
					[options]="types()"
					[placeholder]="'base.field.select_please' | transloco"
					[searchPlaceholder]="'base.field.search_placeholder' | transloco"
					[noResultsText]="'base.field.no_results' | transloco"
					[ariaLabel]="'base.field.disability_type' | transloco"
					[required]="true"
					[hasError]="hasError(typeCtrl, 'required')"
					[errorMessage]="'base.form.error.disability_type_required' | transloco"
				></lvr-searchable-select>
			} @else {
				<p class="readonly">{{ kind().disabilityType?.remark }}</p>
			}
		</lvr-field>

		<!-- Differentiation -->
		<ng-template #differentiationOption let-type>
			<span class="differentiation-option-content">
				<span>{{ type.description }}</span>
				@if (hasHintText(type.id) | async) {
					<lvr-info-tooltip
						class="differentiation-info-icon"
						[text]="getInfoTextKey(type.id) | transloco"
						[ariaLabel]="differentiationInfoAriaLabel(type.description)"
					/>

					<!-- <button
						type="button"
						mat-icon-button
						class="differentiation-info-btn"
						[matMenuTriggerFor]="infoMenu"
						#infoMenuTrigger="matMenuTrigger"
						(mousedown)="$event.stopPropagation()"
						(click)="$event.stopPropagation()"
						[attr.aria-label]="differentiationInfoAriaLabel(type.description)"
					>
						<mat-icon aria-hidden="true" fontIcon="info"></mat-icon>
					</button>
					<mat-menu #infoMenu="matMenu" xPosition="after" yPosition="below">
						<div class="differentiation-info-menu-content" (mousedown)="$event.stopPropagation()">
							<button
								type="button"
								mat-icon-button
								class="differentiation-info-close-btn"
								aria-label="Info schließen"
								(click)="infoMenuTrigger.closeMenu(); $event.stopPropagation()"
							>
								<mat-icon aria-hidden="true">close</mat-icon>
							</button>
							{{ getInfoTextKey(type.id) | transloco }}
						</div>
					</mat-menu> -->
				}
			</span>
		</ng-template>
		<lvr-field [label]="'base.field.differentiation' | transloco">
			<lvr-searchable-select
				formControlName="differentiation"
				[options]="subTypes()"
				[optionLabel]="subtypeLabel"
				[optionTemplate]="differentiationOption"
				[placeholder]="'base.field.select_please' | transloco"
				[searchPlaceholder]="'base.field.search_placeholder' | transloco"
				[noResultsText]="'base.field.no_results' | transloco"
				[ariaLabel]="'base.field.differentiation' | transloco"
				[hintText]="'client.disability.type.create.differentiation_hint' | transloco"
			></lvr-searchable-select>
		</lvr-field>

		<!-- Since -->
		@let sinceCtrl = form.get('since');
		<lvr-field [label]="'client.disability.type.edit.since' | transloco">
			@if (canEdit('since')) {
				<mat-form-field lvrInput [lvrError]="hasError(sinceCtrl, 'maxlength')">
					<input
						matInput
						formControlName="since"
						placeholder="1990"
						[errorStateMatcher]="matcher"
						[maxlength]="env.typeSettings.maxSinceLength"
					/>
					@if (hasError(sinceCtrl, 'maxlength')) {
						<mat-error>{{
							'client.disability.type.create.error.max_length' | transloco: { max: env.typeSettings.maxSinceLength }
						}}</mat-error>
					} @else {
						<mat-hint>{{
							'base.field.remark_hint'
								| transloco: { actual: sinceCtrl?.value?.length || 0, max: env.typeSettings.maxSinceLength }
						}}</mat-hint>
					}
				</mat-form-field>
			} @else {
				<p class="readonly">{{ kind().since }}</p>
			}
		</lvr-field>

		<!-- Recovered on -->
		@let recoveredOnCtrl = form.get('recoveredOn');
		<lvr-field [label]="'client.disability.type.edit.recovered_on' | transloco">
			@if (canEdit('recoveredOn')) {
				<mat-form-field
					lvrInput
					[lvrError]="hasError(recoveredOnCtrl, 'matDatepickerParse', 'matDatepickerMin', 'matDatepickerMax')"
				>
					<input
						matInput
						[matDatepicker]="picker2"
						[min]="minRecoveredOnDate()"
						[max]="maxRecoveredOnDate()"
						formControlName="recoveredOn"
						placeholder="04.06.2013"
						[errorStateMatcher]="matcher"
					/>
					@if (hasError(recoveredOnCtrl, 'matDatepickerParse')) {
						<mat-error>{{ 'base.form.error.date_format_invalid' | transloco: { format: dateFormatHint } }}</mat-error>
					} @else if (hasError(recoveredOnCtrl, 'matDatepickerMin')) {
						<mat-error>{{
							'base.form.error.date_min_error'
								| transloco: { minDate: (minRecoveredOnDate() | date: dateDisplayFormat) }
						}}</mat-error>
					} @else if (hasError(recoveredOnCtrl, 'matDatepickerMax')) {
						<mat-error>{{ 'base.form.error.date_max_error' | transloco }}</mat-error>
					} @else if (hasError(recoveredOnCtrl, 'required')) {
						<mat-error>{{ 'client.disability.type.edit.error.required' | transloco }}</mat-error>
					}
					<mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
					<mat-datepicker #picker2></mat-datepicker>
					<mat-hint>{{ dateFormatHint }}</mat-hint>
				</mat-form-field>
			} @else {
				<p class="readonly">
					{{ isValidDate(kind().recoveredOn) ? (kind().recoveredOn | date: dateDisplayFormat) : '' }}
				</p>
			}
		</lvr-field>

		<!-- Remark -->
		@let remarkCtrl = form.get('remark');
		<lvr-field [label]="'client.disability.type.edit.remark' | transloco">
			@if (canEdit('remark')) {
				<mat-form-field lvrInput [lvrError]="hasError(remarkCtrl, 'maxlength')">
					<input
						matInput
						formControlName="remark"
						placeholder="ein Bemerkungstext zur Behinderungsart"
						[errorStateMatcher]="matcher"
						[maxlength]="env.typeSettings.maxRemarkLength"
					/>
					@if (hasError(remarkCtrl, 'maxlength')) {
						<mat-error>{{
							'client.disability.type.create.error.max_length' | transloco: { max: env.typeSettings.maxRemarkLength }
						}}</mat-error>
					} @else {
						<mat-hint>{{
							'base.field.remark_hint'
								| transloco: { actual: remarkCtrl?.value?.length || 0, max: env.typeSettings.maxRemarkLength }
						}}</mat-hint>
					}
				</mat-form-field>
			} @else {
				<p class="readonly">{{ kind().remark }}</p>
			}
		</lvr-field>

		<!-- Placeholder (Spacer) -->
		<div></div>

		<!-- Documents -->
		@let filesCtrl = form.controls.documents;
		@if (canEdit('documents') && hasEditable() && kind().documents.length < env.typeSettings.maxFiles) {
			<lvr-field [label]="'client.disability.type.edit.documents' | transloco">
				<ul>
					@for (doc of kind().documents; track doc.id) {
						<li>{{ doc.name }}</li>
					}
				</ul>
				<lvr-document-upload
					[subjectType]="subjectType"
					[maxFileCount]="remainingDocumentSlots()"
					[hasError]="hasFileError(filesCtrl, 'requiredFile', 'maxFiles', 'maxFileSize', 'allowedFileTypes')"
					[maxFileSize]="env.fileSettings.maxFileSize"
					[multiple]="true"
					formControlName="documents"
					[showIcon]="true"
					[ownerId]="client().uuid"
				>
				</lvr-document-upload>
			</lvr-field>
		} @else if (canEdit('documents') && hasEditable() && kind().documents.length >= env.typeSettings.maxFiles) {
			<lvr-field [label]="'client.disability.type.edit.documents' | transloco">
				<ul>
					@for (doc of kind().documents; track doc.id) {
						<li>{{ doc.name }}</li>
					}
				</ul>
			</lvr-field>
		} @else if (canEdit('documents')) {
			<lvr-document-upload
				[subjectType]="subjectType"
				[maxFileCount]="remainingDocumentSlots()"
				[hasError]="hasFileError(filesCtrl, 'requiredFile', 'maxFiles', 'maxFileSize', 'allowedFileTypes')"
				[maxFileSize]="env.fileSettings.maxFileSize"
				[multiple]="true"
				formControlName="documents"
				[showIcon]="true"
				[ownerId]="client().uuid"
			>
			</lvr-document-upload>
		}
	</section>

	<p lvrPadding [padHorizontal]="16" [padVertical]="0">{{ 'base.form.required' | transloco }}</p>

	<lvr-default-actions
		[disableSave]="form.invalid || !canEditDisabilityKindsPermission()"
		[showLoading]="isLoading()"
		(save)="update()"
		(cancelSave)="cancel()"
	>
		<lvr-restore-actions entityType="disabilityType" [entityId]="draftId()"></lvr-restore-actions>
	</lvr-default-actions>
</form>
